import { Geolocation } from "@capacitor/geolocation";
import axios from "axios";
export default {
  state: {
    categories: [],
    insets: {},
    filters: {
      category: null,
      island: null,
    },
    languages: [
      {
        name: "Ελληνικά",
        engName: "Greek",
        code: "el",
      },

      {
        name: "German",
        engName: "German",
        code: "de",
      },

      {
        name: "English",
        engName: "English",
        code: "en",
      },
    ],

    snackbar: {
      open: false,
      text: null,
      color: null,
      top: false,
      timeoute: 3,
    },

    location: {
      latitude: 0,
      longitude: 0,
    },

    mobileLang: JSON.parse(localStorage.getItem("mobileLang")) || null,
  },

  mutations: {
    getLocation(state, location) {
      state.location = location;
    },

    setInsets(state, insets) {
      state.insets = insets;
    },

    setFilters(state, filters) {
      state.filters = filters;
    },

    setCategories(state, categories) {
      state.categories = categories;
    },

    setMobileLang(state, lang) {
      if (typeof lang == "string") {
        const langObj = state.languages.find((el) => el.code == lang);
        state.mobileLang = langObj;
        localStorage.setItem("mobileLang", JSON.stringify(langObj));

        axios.defaults.headers.common["Accept-Language"] = `${langObj.code}`;
      } else {
        state.mobileLang = lang;
        localStorage.setItem("mobileLang", JSON.stringify(lang));
        axios.defaults.headers.common["Accept-Language"] = `${lang.code}`;
      }
    },

    toggleSnackbar(state, snackbar) {
      state.snackbar = {
        ...state.snackbar,
        ...snackbar,
      };
    },
  },

  actions: {
    async getLocation({ commit }) {
      try {
        const coordinates = await Geolocation.getCurrentPosition();
        commit("getLocation", {
          latitude: coordinates.coords.latitude,
          longitude: coordinates.coords.longitude,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async getCategories({ commit }) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/categories`
        );
        commit("setCategories", res.data);
      } catch (e) {
        throw e;
      }
    },
  },
};
